import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { GridOptions, GridApi } from 'ag-grid-community';
import { stateOptionsSample, DatePickerGlobalOptions } from 'src/app/constants/service.constants';
import { EditOthersRenderer } from './edit-others-operations.component';
import * as find from 'lodash/find';
import { Route, ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EditAndDeleteOperationsRenderer } from './edit-and-delete-operations.component';

@Component({
  selector: 'app-client-grid',
  templateUrl: './client-grid.component.html',
  styleUrls: ['./client-grid.component.scss']
})
export class ClientGridComponent implements OnInit {

  @Input() search?: boolean = true;
  @Input() gridApi: GridApi;
  @Input() gridBar?= true;
  @Input() gridOptions?: GridOptions;
  @Input() rowData;
  @Input() selectedRow?;
  @Input() gridOperations?;
  @Input() enableGridOperations?;
  @Input() advanceSearch?;
  @Input() hasFloatingFilter?: boolean = false;
  @Input() noFitColumnSizeSet?: boolean = false;
  @Input() skipCaseDetails?: boolean = false;
  @Input() operations?;
  @Input() caseDetails?;
  @Input() noView?= false;
  @Input() RequiredSettings = false;
  @Input() RequiredUserIcon = false;
  @Input() RequiredEdit = false;
  @Input() RequiredView = false;
  @Input() firstSelected?= false;
  @Input() pagination?= true;
  @Input() TargetName?;
  @Input() RequiredSendBackRowData?: boolean = false;

  @Output() setGridApi = new EventEmitter();
  @Output() selectionChanged = new EventEmitter();
  @Output() rowDoubleClicked = new EventEmitter();
  @Output() UserIconCLick = new EventEmitter();
  @Output() gridOperationClicked = new EventEmitter();
  @Output() callbackOperation = new EventEmitter();
  @Output() advanceSearchOperation = new EventEmitter();
  private _columnDefs;
  private caseDetailsSelectedRow = {};
  get columnDefs() {
    return this._columnDefs;
  }
  @Input() set columnDefs(columnDefs) {
    if (columnDefs && this.gridBar) {
      // this._columnDefs = columnDefs;
      let columnDefsHolder = [];
      columnDefs.forEach((item: any) => {
        item.tooltipField = item.field;
        columnDefsHolder.push(item);
      });
      this._columnDefs = columnDefsHolder;

      if (find(this._columnDefs, { 'noedit': "noeditOthersRenderer" })) {
        this._columnDefs = columnDefs;
      }
      else
        if (!find(this._columnDefs, { 'cellRenderer': "editOthersRenderer" })) {
          this._columnDefs.push({
            headerName: "Actions",
            field: "value",
            cellRenderer: "editOthersRenderer",
            colId: "params",
            width: 180,
            sortable: false,
            cellStyle: { "overflow": 'visible' }
          })
        }
    } else {
      this._columnDefs = columnDefs;
    }

    let regex = new RegExp(/(0?[1-9]|[12][0-9]|3[01])-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-\d{4}/g)

    if (this._columnDefs !== null && this._columnDefs !== undefined && this._columnDefs.length > 0){
      this._columnDefs.forEach(element =>
        element.comparator = function (valueA, valueB, nodeA, nodeB, isInverted) {
          if (valueA !== null && valueB !== null && (typeof valueA === 'string')) {
            if (valueA.match(regex) != null && valueB.match(regex) != null)
              return Date.parse(valueA) - Date.parse(valueB);
            else
              return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
          }
          else if (valueA !== null && valueB !== null && (typeof valueA === 'number'))
            return valueA - valueB;
          else return true;
        }
      );

      // this._columnDefs.forEach(element =>
      //   element.comparator = function (valueA, valueB, nodeA, nodeB, isInverted) {
      //       debugger
      //     if (valueA.match(regex)) {
      //       let date1 =new Date(valueA);
      //       let date2 = new Date(valueB);
        
      //       valueA = valueA.split("-")
      //       valueB =valueB.split("-")
        
      //       const day1 = parseInt(valueA[0])
      //       const month1 = (date1.getMonth() + 1)
      //       const year1 = parseInt(valueA[2])
      //       const day2 = parseInt(valueB[0])
      //       const month2 = (date2.getMonth() + 1)
      //       const year2 = parseInt(valueB[2])
        
      //       if (year1 !== year2)
      //         return year1 - year2
      //       else if (month1 !== month2)
      //         return month1 - month2
      //       else 
      //         return day1 - day2;
           
      //       }});
    }
  };


  app_ext: Boolean = false;
  toggleCaseDetails: Boolean = false;
  collapesedOrNot: Boolean = false;

  searchValue: string;
  showAdv : boolean = true;
  basicOptions = stateOptionsSample;
  frameworkComponents;
  context;
  advInfoLabels;

  
  
  constructor(private modalService: NgbModal, private route: ActivatedRoute,
    private router: Router) {
    const customComparator = (valueA, valueB) => {
      return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
    };

    this.gridOptions = {
      pagination: true,
      rowSelection: 'single',
      rowHeight: 32,

      defaultColDef: {
        sortable: true,
        suppressNavigable: true,
        cellClass: 'no-border',
        suppressMovable: true,

      }
    }
    this.context = { componentParent: this };
    this.frameworkComponents = {
      editOthersRenderer: EditOthersRenderer,
      editAndDeleteOperationsRenderer:EditAndDeleteOperationsRenderer
    };

  }


  onGridReady(params) {
    
    this.gridApi = params.api;
    this.setGridApi.emit(this.gridApi);
    setTimeout(() => {
      if (this.firstSelected) {
        params.api.forEachNode(node => node.rowIndex ? 0 : node.setSelected(true));
      }
      if (!this.noFitColumnSizeSet) {
        this.gridApi.sizeColumnsToFit();
      }
    }, 500);
  }

  onSelectionChanged(event) {
    if (this.caseDetails) {
      this.caseDetailsSelectedRow = event.api.getSelectedRows()[0];
      if(this.caseDetailsSelectedRow["SKIP_FLAG"]=="S")
      {
        if(this.caseDetailsSelectedRow["GRANTTYPE"]!="CME")
        {
          this.caseDetails.forEach((elemet,index)=>{
            elemet.caseSet.caseData.forEach((celemet,cindex)=>{
              if(celemet["label"]=="Budget Allocated")
              {
                celemet["Skip"]="T";
              }
              if(celemet["label"]=="Reconciliation Amount")
              {
                celemet["Skip"]="T";
              }
            });
  
          })  
        }
        else{
          this.caseDetails.forEach((elemet,index)=>{
            elemet.caseSet.caseData.forEach((celemet,cindex)=>{
              if(celemet["label"]=="Budget Allocated")
              {
                celemet["Skip"]="F";
              }
              if(celemet["label"]=="Reconciliation Amount")
              {
                celemet["Skip"]="F";
              }
            });
  
          })  
        }
      }
    
    }
    this.selectionChanged.emit(event);
  }

  clearCase(casedetails) {
    this.caseDetailsSelectedRow = casedetails;
  }
  onRowDoubleClicked(event) {
    //this.rowDoubleClicked.emit(event);
  }

  onGridOperationClick(operation) {
    this.gridOperationClicked.emit(operation)
  }

  editButton() {
    setTimeout(() => {
      this.onSelectRow();
    }, 300);
  }
 
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnInit() {
    this.advInfoLabels = this.advanceSearch;
    this.route.queryParams
      .subscribe(params => {
        if (params && params.app_ext) {
          this.app_ext = true
          this.toggleCaseDetails = false;
        } else {
          this.app_ext = false;
        }
        window['app_ext'] = this.app_ext;
      });


    // if (location.href) {
    //   location.href.indexOf('application-ext') > -1 ? this.app_ext = true : this.app_ext = false;
    //   window['app_ext'] = this.app_ext;
    //   this.toggleCaseDetails = false;
    // }
    if (this.skipCaseDetails) {
      this.app_ext = true;
      window['app_ext'] = this.app_ext;
      this.toggleCaseDetails = false;
    }
    if (!this.app_ext) {
      this.toggleCaseDetails = true
    }
  }

  advanceSearchOpen() {
    // let modalRef = this.modalService.open(AdvanceSearchComponent,
    //   {
    //     backdrop: false,
    //     keyboard: false,
    //     windowClass: 'modal-llg right modal-right',
    //     animation: true
    //   }
    // );
    // modalRef.componentInstance.Content= {
    //   advanceSearch: this.advanceSearch
    // }
  }


  onSelectRow() {
    if (this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length)
      this.rowDoubleClicked.emit({ data: this.gridApi.getSelectedRows()[0] })
  }
  userIconClick() {
    setTimeout(() => {
      this.IconClickEmit();
    }, 300);

  }
  IconClickEmit() {
    //;
    if (this.gridApi.getSelectedRows() && this.gridApi.getSelectedRows().length)
      this.UserIconCLick.emit({ data: this.gridApi.getSelectedRows()[0] })
  }
  toggleCase(result) {
    this.toggleCaseDetails = result;
    setTimeout(() => {
      this.gridApi.sizeColumnsToFit();
    })
  }

  onOperationClick(operation) {
   if(this.RequiredSendBackRowData==false)
    {
      setTimeout(() => {
        this.callbackOperation.emit(operation);
      }, 300)
    }
  }


}

